import React, { useState, useEffect } from "react";
import "../styles/cookie-banner.css";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    // Provjeri je li korisnik već prihvatio ili odbio kolačiće
    const cookieConsent = localStorage.getItem("cookieConsent");
    console.log("Cookie consent check:", cookieConsent); // Debug
    if (!cookieConsent) {
      // Dodaj malu delay da se osigura da je stranica učitana
      setTimeout(() => {
        setShowBanner(true);
        console.log("Showing cookie banner"); // Debug
      }, 500);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem("cookieConsent", "rejected");
    setShowBanner(false);
  };

  if (!mounted || !showBanner) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <p>
            Ova stranica koristi kolačiće kako bi osigurala najbolje korisničko iskustvo.
            Nastavkom korištenja stranice pristajete na korištenje kolačića.{" "}
            <a href="/privacy-policy">Saznaj više</a>
          </p>
        </div>
        <div className="cookie-banner-actions">
          <button className="cookie-btn-accept" onClick={acceptCookies}>
            Prihvati
          </button>
          <button className="cookie-btn-reject" onClick={rejectCookies}>
            Odbij
          </button>
        </div>
      </div>
    </div>
  );
}

